<template>
  <div>
    <v-stage
        ref="stage"
        :config="config">
      <v-layer
          ref="layer">
        <v-group
            v-for="zone in drawnZones()"
            :ref="'group-'+zone.uniqueId"
            :key="zone.uniqueId"
            :data="zone"
            :config="zone.config.group"
            @mousedown="handleGroupMousedown"
            @dragend="handleGroupDragend">
          <v-line
              :ref="'line-'+zone.uniqueId"
              :config="zone.config.line"
              :data="zone"
              @click="handleLineClick" />
          <v-circle
              v-for="point in zone.vertices"
              v-if="draggable"
              :ref="'circle-'+point.uniqueId"
              :key="point.uniqueId"
              :data="point"
              :config="zone.config.circles"
              :x="point.ui.x"
              :y="point.ui.y"
              :radius="4"
              :visible="zone.selected"
              @dragmove="handleCircleDragmove"
              @mouseenter="handleCircleMouseenter"
              @mouseleave="handleCircleMouseleave" />
        </v-group>
      </v-layer>
    </v-stage>
  </div>
</template>

<script>
export default {
  name: "AerialZonesCanvas",
  props: {
    zones: {
      type: Array,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      draggable: false,
    };
  },
  watch: {
    zones: {
      handler() {
        this.updateSelectedZone();
      },
      deep: true,
    },
  },
  mounted() {
    this.draggable = !!this.config.draggable;
    this.config.draggable = false;
    this.updateSelectedZone();
  },
  methods: {
    drawnZones() {
      return this.zones.filter((zone) => zone.drawn);
    },
    findZoneByUniqueId(uniqueId) {
      return this.zones.find((zone) => zone.uniqueId === uniqueId);
    },
    selectZone(zone) {
      if (!zone) return;
      const zoneUniqueId = zone.uniqueId;
      this.drawnZones().forEach(
        (zone) => (zone.selected = zone.uniqueId === zoneUniqueId)
      );
      this.updateSelectedZone();
    },
    handleCircleDragmove(e) {
      const point = e.target.attrs.data;
      point.ui.x = e.target.attrs.x;
      point.ui.y = e.target.attrs.y;
      this.convertScreenPointToDataPoint(point, point.ui, this.config);

      const line = this.$refs["line-" + point.zone.uniqueId][0].getNode();
      line.attrs.points = point.zone.vertices
        .map((point) => [point.ui.x, point.ui.y])
        .flat();
      point.zone.vertices.updated = true;
    },
    handleCircleMouseenter() {
      if (!!this.config.draggable) {
        const stage = this.$refs.stage.getStage();
        stage.container().style.cursor = "pointer";
      }
    },
    handleCircleMouseleave() {
      if (!!this.config.draggable) {
        const stage = this.$refs.stage.getStage();
        stage.container().style.cursor = "default";
      }
    },
    handleGroupMousedown(e) {
      const zoneUniqueId = e.target.attrs.data.uniqueId;
      this.selectZone(this.findZoneByUniqueId(zoneUniqueId));
    },
    handleGroupDragend(e) {
      const zoneUniqueId = e.target.attrs.data.uniqueId;
      const zone = this.findZoneByUniqueId(zoneUniqueId);
      if (!zone) return;

      zone.vertices.forEach((point) => {
        const circles = this.$refs["circle-" + point.uniqueId];
        if (circles && circles.length) {
          const position = circles[0].getNode().absolutePosition();
          this.convertScreenPointToDataPoint(point, position, this.config);
        }
      });
      zone.vertices.updated = true;
    },
    handleLineClick(e) {
      const zoneUniqueId = e.target.attrs.data.uniqueId;
      this.selectZone(this.findZoneByUniqueId(zoneUniqueId));
    },
    convertScreenPointToDataPoint(point, uiPoint, config) {
      point.x = (uiPoint.x / config.width) * 20 - 10;
      point.y = (uiPoint.y / config.height - 1) * -10;
    },
    updateSelectedZone() {
      if (!this.zones || !this.zones.length) return;

      let redraw = false;

      this.drawnZones().forEach((zone) => {
        zone.vertices.forEach((point) => {
          const circles = this.$refs["circle-" + point.uniqueId];
          if (circles && circles.length) {
            circles[0].getNode().visible(!!zone.selected);
            redraw = true;
          }
        });
      });

      if (redraw) this.$refs.layer.getNode().draw();
    },
  },
};
</script>

<style lang="scss">
/* [role="presentation"] */
div.konvajs-content {
  background: #f5f5f5 !important;
  border-radius: 10px !important;
}
</style>
